export const buildFailedPaymentPayload = ({
  error,
  orderData,
  registrationDbId,
  formData,
}) => ({
  regId: registrationDbId,
  razorpayOrderId: orderData?.id || orderData?.orderId || "unknown",
  razorpayPaymentId: null,
  razorpaySignature: null,
  status: "FAILED",
  paymentStatus: "FAILED",
  amount: orderData?.amount || 0,
  amountPaid: 0,
  currency:
    orderData?.currency || (formData.country === "India" ? "INR" : "USD"),
  paymentMethod: "razorpay",
  paymentGateway: "Razorpay",
  transactionTime: new Date().toISOString(),
  failureTime: new Date().toISOString(),
  orderAmount: orderData?.amount ? orderData.amount / 100 : 0,
  gatewayTransactionId: null,
  errorCode: error?.code || "UNKNOWN_ERROR",
  errorDescription: error?.description || error?.message || "Unknown error",
  errorSource: error?.source || "razorpay",
  errorStep: error?.step || "payment_gateway",
  errorReason: error?.reason || "payment_failed",
  metadata: JSON.stringify({
    userAgent: navigator.userAgent,
    timestamp: Date.now(),
    errorDetails: {
      code: error?.code,
      description: error?.description,
      source: error?.source,
      step: error?.step,
      reason: error?.reason,
    },
    orderInfo: {
      orderId: orderData?.id || orderData?.orderId,
      amount: orderData?.amount,
      currency: orderData?.currency,
    },
    userInfo: {
      email: formData.email,
      mobile: formData.mobile,
      country: formData.country,
      name: `${formData.firstName} ${formData.lastName}`.trim(),
    },
  }),
});

export const saveFailedPayment = async ({
  paymentSaveUrl,
  error,
  orderData,
  registrationDbId,
  formData,
  savePaymentWithBreakdown,
}) => {
  const failedPaymentData = buildFailedPaymentPayload({
    error,
    orderData,
    registrationDbId,
    formData,
  });

  const failedPaymentResult = await savePaymentWithBreakdown({
    paymentSaveUrl,
    payload: failedPaymentData,
  });

  if (!failedPaymentResult.ok) {
    const errorText = failedPaymentResult.errorText;
    console.warn("Failed to capture failed payment:", errorText);
  }

  return failedPaymentResult;
};
